import LanguageMessages from "./LanguageMessages";

const germanMessages: LanguageMessages = {
    NavBar: {
        HomeTitle: 'Home',
        AccordionsTitle: 'Akkordeons',
        ContactTitle: 'Kontakt',
        CompanyTitle: 'Unternehmen',
        TeamTitle: 'Team',
        LogoutTitle: 'Abmelden',
        AccessoriesTitle: 'Zubehör',
    },
    RollingCredits: {
        DialogTitle: 'Text verwalten',
    },
    Footer: {
        firm: "Firma",
        addressLineOne: "Generalvertretungen Schweiz",
        addressLineTwo: "PIGINI & EXCELSIOR",
        addressLineThree: "Martin Frey",
        address: "Untere Holzstrasse 9",
        plz: '5036',
        city: 'Oberentfelden',
        telephone: 'Festnetz: +41 62 827 21 61',
        mobile: 'Mobil: +41 79 239 77 94',
        emailLabel: 'E-Mail:',
        email: 'info@pigini.ch'
    },
    HomePage: {
        HomeShopShortcut: {
            titleText: 'Entdecken Sie unsere feine Auswahl an Akkordeons, darunter speziell ausgewählte Stücke von Pigini und Excelsior Akkordeons. Erleben Sie den Charme und die Handwerkskunst dieser wunderschön gestalteten Instrumente. Tauchen Sie ein in die Welt dieser meisterhaft gefertigten, künstlerischen Instrumente.'
        }
    },
    TeamPage: {
        title: 'Team',
        teamMembers: [
            {
                name: 'Martin Frey',
                text: [
                    '',
                    '[[[bold]]]Ausbildungen',
                    'Hochschule Abteilung für Bauingenieurwesen (Brugg-Windisch / CH)',
                    '- Dipl. Bauingenieur HTL (später FH)',
                    'Nachdiplomstudien: ',
                    '- MAS-ND-U (Unternehmensführung / Hochschule Luzern in Horw / CH)',
                    '- MAS-CIM (Computerintegriertes Manufacturing / Brugg-Windisch / CH)',
                    '',
                    '[[[bold]]]Projektleiter & Engineering',
                    'Langjährige Erfahrungen im nationalen  Tief- & Hochbau, internationale Erfahrungen in der Maschinenindustrie (einschließlich der Herstellung von Akkordeons), der Automobil-Zulieferer-Industrie, der Luft- und Raumfahrttechnik, der Robotik. Langjährige Erfahrung in nationalen & internationalen Consulting & Prozess-Modellierung & -Simulations- Projekten (Aeneis, Six-Sigma, Wassermann {Prozess-Simulation} SAP-R3), SOX- & IKS- Systeme.',
                    'Nationale & internationale Prozess-Projekte in grossen Energieproduktionsfirmen.',
                    '',
                    '[[[bold]]]Internationale Musikerfahrungen',
                    'Veranstalter von Konzerten und Seminaren in verschiedenen Richtungen und Genres, einschließlich Akkordeonkonzerte. (Friedrich Lips, Viacheslav Semjonov, Yuri Shishkin, Frank Marocco, Timbre Russian Accordions Group of Moskau, Orchester von Pavel Smirnov, Akkordeonorchester aus Neuseeland, Frank Marocco, Fang Yuan, u.a.)',
                    '',
                    '[[[bold]]]Generalvertretung für Akkordeons',
                    'Für die weltweit führende Herstellerin von High-End Akkordeons der Marken PIGINI & EXCELSIOR',
                    '- 35 Jahre Schweiz & Liechtenstein (Inhaber der Generalvertretung)',
                    '- Ca. 10 Jahre Russland (operative Führung der Generalvertretung)'   
                ]
            }
        ]
    },
    CompanyPage: {
        AboutUs: {
            title: 'Über uns',
            pAndSSwitzerland: {
                subtitle: 'PIGINI & EXCELSIOR Schweiz',
                text: 'State-of-the-Art im Akkordeonbau. Vollendete Harmonie von Tradition, Innovation und Qualitätsbewusstsein. PIGINI setzt kompromisslos auf die langjährige Erfahrung der talentiertesten italienischen Instrumentenbauer.',
            },
            relationships: {
                subtitle: 'Verbundenheit',
                text: 'Um die bestmöglichen Instrumente bauen zu können, legt PIGINI Wert auf eine enge Verbundenheit mit den weltbesten Solisten, Orchestern, Konservatorien, Schulen und Akkordeonlehrern. Diese Beziehungen via PIGINI\'s weltweites Netz von Generalvertretungen sind die Erfolgsfaktoren für Instrumente, die ihresgleichen suchen.',
            },
            since: {
                subtitle: 'PIGINI & EXCELSIOR Schweiz seit 1990',
                text: 'Im Jahr 1990 hat sich die Handels- & Generalvertretung für den Schweizer Markt der Philosophie von PIGINI und EXCELSIOR verpflichtet und bürgt seither für Instrumente in Spitzenqualität und einen Kundenservice, der solch edlen Instrumenten gerecht wird.\n' +
                    '\n' +
                    'Wir sind stolz, Ihnen Akkordeons anbieten zu können, die keine Wünsche offen lassen betreffend Klang und Qualität.',
            },
            ourService: {
                subtitle: 'Unser Service',
                text: 'Zögern Sie nicht unsere Dienstleistungen in Anspruch zu nehmen. Ob Sie bei einem Kauf individuelle Wünsche haben oder ein Instrument mieten möchten, Sie erhalten von uns stets eine seriöse und ehrliche Beratung.'
            },
            comeSee: {
                subtitle: 'Probespielen',
                text: 'Kontaktieren Sie uns für einen Termin, um bei einem Probespiel das für Sie in Grösse und Klang passende Instrument zu finden. Bei der PIGINI & EXCELSIOR Generalvertretung Schweiz werden Sie von leidenschaftlichen Vertretern des Akkordeons und der Akkordeonmusik empfangen. Wir freuen uns auf Ihren Besuch und heissen Sie herzlich willkommen in unserer Welt!',
            },
        },
        AboutPigini: {
            title: 'Über Pigini',
            tradition: {
                subtitle: 'Tradition',
                text: 'Am 6. Juni 1946 trug Filippo Pigini die Firma "F.lli PIGINI di Filippo", zusammen mit seinen Söhnen Adriano, Gino, Luigi und Marino Pigini als Geschäftspartner, bei der Handelskammer in Ancona ein. Filippo Pigini, ein Mann mit aussergewöhnlichem Unternehmergeist, sorgte dafür dass seine Söhne, die gerade von der Kriegsfront zurückkamen, die Arbeit in der 1930 gegründeten Schreinerei der Familie wieder aufnahmen. Zu dieser Zeit wurden auch die ersten Akkordeons hergestellt.'
            },
            foundingYears: {
                subtitle: 'Die Gründungsjahre',
                text: 'Die Nachkriegszeit war hart, doch die jungen Geschwister liessen sich nicht unterkriegen. Die Notwendigkeit, ihren Lebensunterhalt zu bestreiten und ihre grosse Begeisterung trieben sie dazu an, eine der dynamischsten Firmen des Akkordeonbaus zu gründen. Die ersten Lieferungen gingen in die USA, dann nach Kanada, Schweden, Dänemark, Argentinien, Ägypten und Pakistan, was schon in den Gründungsjahren der Firma die Weichen stellte für den internationalen Geist, welcher dem Unternehmen PIGINI heute zu eigen ist.',
            },
            ginoPigini: {
                subtitle: 'Gino Pigini',
                text: 'Die Führung des Unternehmens lag mehrere Jahre lang in den Händen von Gino Pigini, der bereits im Alter von 14 Jahren ein erfahrener "Vociarolo" (Stimmenmacher) war. Er setzte grosses Vertrauen in den Ideenreichtum der Jugend und in deren Lernwillen. In kürzester Zeit stellte er eine Gruppe von aussergewöhnlichen Akkordeonbaumeistern zusammen. Seine Anstrengungen sowie seine Arbeitsphilosophie bilden auch heute noch die Grundlage für die PIGINI-Spitzenqualität.',
            },
            philosophy: {
                subtitle: 'Unternehmensphilosophie',
                text: 'Die Zukunft analysieren, die Vergangenheit kapitalisieren. Mit diesem Geist greift das PIGINI-Team jede Herausforderung an. Mit Leidenschaft und Liebe, betrachtet es das Akkordeon als ein Musikinstrument, in dem Kunst und Technik, dank eingehender Fachkenntnis, die nur durch große Erfahrung möglich ist, gleichwertig behandelt werden.\n' +
                    '\n' +
                    'Das weltweite Ansehen, das PIGINI-Instrumente geniessen, sticht nun bereits seit mehreren Jahrzehnten hervor, da die geschätztesten Musikhochschulen und die renommiertesten Akkordeonvirtuosen uns ihren Vorzug eingeräumt haben. Diesen Ruf verdankt PIGINI ihrer absolut stabilen Qualitätsgrundlage, die sie zur führenden Marke in dieser Branche macht.',
            },
            craftsmanship: {
                subtitle: 'Handwerkliche Fertigung',
                text: 'Die Beachtung der handwerklichen Tradition bedient sich bei den PIGINI-Akkordeons der modernsten Technologien, in der Absicht diese im Laufe der Jahrhunderte gesammelten Erfahrungen noch weiter auszubauen, um immer grössere und fortschrittlichere Horizonte erreichen zu können.'
            },
            topQualityMaterials: {
                subtitle: 'Materialqualität',
                text: 'Jedes einzelne PIGINI-Musikinstrument ist ein aus speziellem Material hergestelltes Kunstwerk. Das Holz wird stets gemäss strenger Prüfungskriterien ausgewählt. Die Stimmplatten, die Seele des Instruments, werden in der eigenen Fabrik hergestellt (je nach Modell handgemacht) und sind wegen ihrer exzellenten Klangqualität weltweit bekannt. Der Balg, der mit einer speziellen Kartonpaste hergestellt wird, erzeugt den vom Spieler gewünschten idealen Innendruck. Auch die Lackfarben, die Filze sowie die Lederstücke gehören zu den besten, so daß es zur Verwirklichung eines bis ins Detail gepflegten hochwertigen Instruments kommt.',
            },
            careForDetail: {
                subtitle: 'Detailbearbeitung',
                text: 'Die Klangabstrahlung hat ihre Stärke in der Fülle und Reinheit, die nur bei Beseitigung aller auch kleinster mechanischer Geräusche gewährleistet werden kann. Aus diesem Grunde sind alle Mechanismen der PIGINI-Akkordeons sorgfältig mit Dämpfungsfilzen versehen. Ausserordentliche Geräuscharmut erhebt diesen hohen Standard der Klangreinheit, der von allen Musikspezialisten sofort wiedererkannt wird.',
            },
            selection: {
                subtitle: 'Breitgefächertes Modellspektrum',
                text: 'Der PIGINI-Katalog bietet mehr als 60 verschiedene Modelle, um auch die unterschiedlichsten Wünsche der Musiker zu erfüllen. Das Musikinstrument muß sich bekanntlich den Bedürfnissen seines Spielers anpassen, sei es ein junger Anfänger oder ein berühmter Konzertmusiker. Die Eigenschaften der PIGINI-Akkordeons sind für den gesamten Studiengang optimal und entsprechen allen Anforderungen der Hobby- und Berufsmusiker.',
            },
            qoi: {
                subtitle: 'Anhaltender Wert',
                text: 'Die Qualität der handwerklichen Arbeit und die Verwendung exklusiver Materialien macht jedes PIGINI-Akkordeon zu einer lohnenden Investition mit exzellentem Werterhalt für viele Jahre. Weil jedes Akkordeon schlussendlich ein Einzelstück ist, kann sein Wert über die Jahre nur steigen.',
            },
            uniqueness: {
                subtitle: 'Einzigartigkeit',
                text: 'Eine einzelne Schraube, das einfache Schneiden von Holz, die Ausgewogenheit der Proportionen, die Stärke der Filze, die Bearbeitung der Präzisionshebel, das Kalibrieren der Federn. Jeder bei PIGINI strebt nach der Perfektionierung der kleinen, kaum sichtbaren, aber bei Berührung klar spürbaren Details.',
            },
            touch: {
                subtitle: 'Touch',
                text: 'Hinter dem anhaltenden guten Ruf von PIGINI-Instrumenten steht das Streben nach einem immer stärker verfeinerten, faszinierenden Klang, welcher sowohl den Ansprüchen der Musik wie auch der Leidenschaft des individuellen Musikers gerecht wird.\n' +
                    '\n' +
                    'Das Endergebnis ist das einzigartige Spielgefühl, das heute jedes einzelne PIGINI-Instrument auszeichnet.\n' +
                    '\n' +
                    'Diese Eigenschaft verleiht dem Instrument besonderen Sinngehalt, sowie seine einzigartige Bedeutung.',
            }
        },
        AboutExcelsior: {
            title: 'Über Excelsior',
            beginnings: {
                subtitle: 'Die Anfänge',
                text: 'Excelsior wurde 1924 in New York gegründet. Die hohe Qualität der von Excelsior hergestellten Akkordeons machte die Firma rasch in den gesamten Vereinigten Staaten populär.\n' +
                    '\n' +
                    'Den Höhepunkt ihrer Popularität erreichten die Excelsior-Instrumente nach den zweiten Weltkrieg, als sie Muss wurden für jedes grössere Orchester.\n' +
                    '\n' +
                    'Künstler wie Charles Magnante, Art Van Damme und Piero Deiro sind nur einige unter den vielen prominenten Spielern deren Wahl auf Excelsior fiel.',
            },
            expansion: {
                subtitle: 'Expansion',
                text: '1948 wurde ein neues Werk in Castelfidardo, Italien, gegründet, um Produktionskapazitaät und Verkäufe erhöhen zu können. Seitdem werden der hervorragende Klang, die hohe Qualität und das vornehme Auftreten von Excelsior-Akkordeons auf der ganzen Welt geschätzt.',
            },
            heritage: {
                subtitle: 'Das Erbe',
                text: 'Diese Tradition von Qualität und Prestige wird von Excelsior heute fortgeführt. Excelsior-Akkordeons werden nach wie vor mit auserlenenen Materialien und fachkundiger Handwerkskunst gebaut.\n' +
                    '\n' +
                    'Heutzutage ein Excelsior-Akkordeon zu besitzen heisst, ein angesehenes Instrument zu spielen und hoffentlich den besten und populärsten Akkordeon-Künstlern der Vergangenheit und Gegenwart nachzustreben.',
            },
        },
        Consultations: {
            title: 'Beratung',
            appointments: {
                subtitle: 'Termine',
                text: 'Haben wir Ihr Interesse geweckt? Dann kontaktieren Sie uns für ein unverbindliches Probespielen an unserem Geschäftssitz in Oberentfelden. Wir freuen uns auf Ihren Besuch.'
            },
            wideSelection: {
                subtitle: 'Grosse Auswahl',
                text: 'Wir haben stets eine Auswahl an Pigini und Excelsior Instrumenten an Lager, welche Sie nach Herzenslust probespielen können. So können Sie sicher sein, auch wirklich ein Instrument auszuwählen, das zu Ihnen passt und Ihren Bedürfnissen am besten entspricht.',
            },
            service: {
                subtitle: 'Kompetente und ehrliche Beratung',
                text: 'Als langjähriger Akkordeonspieler und jemand, der seit vielen Jahren gute Beziehungen zu einigen der weltbesten Akkordeon-Virtuosos pflegt, kann Ihnen Martin Frey kompetente und ehrliche Auskunft auf alle möglichen Fragen geben und sicherstellen, dass Sie bekommen, was Sie brauchen.',
            }
        },
        Rentals: {
            title: 'Mietinstrumente',
            subtitle: 'Wenn ein Kauf sich nicht lohnt...',
            text: 'Insbesondere bei Kindern im Schulalter macht es häufig noch keinen Sinn, ein Instrument zu kaufen solange die Wachstumsphase noch nicht abgeschlossen ist.\n' +
                '\n' +
                'Für diese Fälle können wir Ihnen diverse Mietinstrumente anbieten. So können Schülerinnen und Schüler stets auf einem Instrument lernen, das ideal zu ihnen passt.',
        },
        Repairs: {
            title: 'Reparaturen',
            subtitle: 'Wenn doch mal etwas ist',
            text: 'Auch nach dem Kauf sind wir Anlaufstelle für diverse Serviceleistungen an Ihrem Akkordeon, sei es für Reparaturen, Änderungen oder Stimmungen. Wir bieten kompetenten und raschen Service.',
        }
    },
    ContactPage: {
        ContactUsCardTitle: 'Anfrage senden',
        ContactUsCardDescription: 'Wir sind auch erreichbar per e-mail: [[[mailto]]]info@pigini.ch oder per Telefon: +41 79 239 77 94',
        areasOfInterest: {
            areasOfInterestTitle: 'Interessen',
            sendFurtherInformationChecboxLabel: 'Bitte senden Sie mir unverbindlich Unterlagen zu Ihren Instrumenten zu.',
            contactMeForTryOutCheckboxLabel: 'Bitte kontaktieren Sie mich betreffend eines Termins zum Probespielen.',
            interestedInRentingCheckboxLabel: 'Ich möchte gerne ein Instrument mieten. Bitte kontaktieren Sie mich mit weiteren Informationen.'
        },
        contactInformation: {
            titleLabel: 'Anrede',
            titleMrValueLabel: 'Herr',
            titleMsValueLabel: 'Frau',
            firstNameLabel: 'Vorname',
            lastNameLabel: 'Nachname',
            streetLabel: 'Strasse',
            houseNumberLabel: 'Hausnummer',
            zipLabel: 'Postleitzahl',
            cityLabel: 'Stadt',
            phoneLabel: 'Festnetz',
            mobileLabel: 'Mobil',
            emailLabel: 'E-Mail',
            preferredMethodOfContactLabel: 'Bevorzugte Kontaktart',
            additionalInformationTitle: 'Zusätzliche Anmerkungen (freiwillig)',
            sendButtonLabel: 'senden'
        }
    },
    AccordionsPage: {
        titleToBuy: 'Akkordeons zum Kauf',
        titleToRent: 'Akkordeons zur Miete',
        Filter: {
            resetFilterBtnLabel: 'Filter zurücksetzen',
            brandTitle: 'Marke',
            generalCategoryTitle: 'Allgemein',
            rightHandCategoryTitle: 'Rechte Hand',
            leftHandCategoryTitle: 'Linke Hand',
            standardBassCategoryTitle: 'Standardbass',
            characteristicsCategoryTitle: 'Merkmale',
            freeBassCategoryTitle: "Freebass",
            isRental: 'Mietobjekt',
            Condition: {
                title: 'Zustand',
                used: 'Gebraucht',
                new: 'Neu',
            },
            BassType: {
                title: 'Bass-Typ',
                convertor: 'Convertor',
                standard: 'Standard',
            },
            RightHandSystem: {
                title: 'System',
                keys: 'Piano',
                buttons: 'Knopf'
            },
            Weight: {
                title: 'Gewicht'
            },
            Height: {
                title: 'Höhe'
            },
            Width: {
                title: 'Breite',
            },
            Rows: {
                title: 'Reihen'
            },
            RightHandButtons: {
                title: 'Knopf Noten',
            },
            ChorusRight: {
                title: 'Chor'
            },
            CassottoRight: {
                title: 'Cassotto',
            },
            RegisterRight: {
                title: 'Register'
            },
            ChinSwitches: {
                title: 'Kinn-Register'
            },
            StandardBassChorus: {
                title: 'Chor',
            },
            RegisterSb: {
                title: 'Register'
            },
            FreeBassNotes: {
                title: 'Noten',
            },
            ChorusFb: {
                title: 'Chor',
            },
            RightNotesPiano: {
                title: 'Piano Noten',
            },
            ReedsFilter: {
                title: 'Stimmzungen',
                tam: 'Tipo a Mano',
                fam: 'Handgemacht',
                durall: 'Durall',
                turbo: 'Turbo',
                none: 'Keine'
            }
        },
        DeleteAccordion: {
            ConfirmationDialogTitle: 'Akkordeon löschen',
            ConfirmationDialogContent: 'Sind Sie sicher, dass Sie das Akkordeon löschen möchten? Einmal gelöscht, müssen Sie den Administrator kontaktieren, um es wiederherzustellen. Daten können während dieses Prozesses verloren gehen.',
        },
        PublishAccordion: {
            ConfirmationDialogTitle: 'Akkordeon veröffentlichen',
            ConfirmationDialogContent: 'Sind Sie sicher, dass Sie das Akkordeon veröffentlichen möchten? Sobald es veröffentlicht ist, kann jeder dieses Akkordeon im Store sehen. Nur der Administrator kann es „zurückziehen“.',
        },
        UnpublishAccordion: {
            ConfirmationDialogTitle: 'Akkordeon unveröffentlichen',
            ConfirmationDialogContent: 'Sind Sie sicher, dass Sie dieses Akkordeon unveröffentlichen möchten? Nach dieser Aktion wird das Akkordeon für die Öffentlichkeit nicht mehr sichtbar sein, bis es erneut veröffentlicht wird.'
        },
        ImageManager: {
            setAsThumbnailButtonLabel: 'Als Thumbnail festlegen'
        },
        accordionNotFoundText: 'Akkordeon nicht gefunden',
        accordionAdditionalInformationContactText: 'Ich interessiere mich für das Akkordeon',
    },
    AccessoriesPage: {
        title: 'Zubehör',
        subtitle: 'Entdecken Sie die perfekte Ergänzung, um Ihr Akkordeon-Erlebnis mit unserer umfangreichen Auswahl an Zubehör zu verbessern. Wenn Ihnen etwas ins Auge fällt, zögern Sie bitte nicht, uns direkt zu kontaktieren. Wenn Sie außerdem ein spezifisches Zubehör suchen, das nicht in unserer Kollektion enthalten ist, zögern Sie nicht, uns zu kontaktieren. Wir sind bestrebt, Ihre Bedürfnisse zu erfüllen und sicherzustellen, dass Sie genau das finden, wonach Sie suchen.',
        Backpacks: {
            title: 'Rucksäcke',
            text: 'Erleben Sie Ihre musikalische Reise neu mit unseren hochwertigen Rucksäcken, die speziell für Akkordeons und CH-Örgeli entwickelt wurden. Diese Rucksäcke bieten nicht nur Bequemlichkeit beim Tragen, sondern auch robusten Schutz und stilvolles Design, das zu Ihrem Instrument passt. Ob Sie professionelle/r Musiker/in oder leidenschaftliche/r Enthusiast/in sind, unsere Rucksäcke garantieren, dass Ihr Akkordeon oder CH-Örgeli komfortabel und stilvoll reist. Entdecken Sie unsere Auswahl an Rucksäcken, die stilvolle Verarbeitung, Langlebigkeit und praktische Details verkörpern.',
            tableData: {
                columnKeyDef: ['text', 'currency', 'price'],
                columnNameDef: ['', '', 'Preis'],
                rows: [
                    { text: 'Akkordeon Rucksack Cordura'        , price: 'Ab 63' , currency: 'CHF / Euro' },
                    { text: 'Schwyzerörgeli Rucksack'           , price: 'Ab 90'    ,  currency: 'CHF / Euro' },
                    { text: 'Tragtasche weich für Concertina'   , price: 'Ab 70'    , currency: 'CHF / Euro' },
                ]
            }
        },
        ShoulderStraps: {
            title: 'Schulterriemen',
            text: 'Entdecken Sie unsere vielfältige Auswahl an Schulterriemen für Akkordeons, erhältlich mit und ohne Querriemen. Diese sind speziell darauf ausgelegt, den individuellen Bedürfnissen jedes/r Musiker/in gerecht zu werden und sind in verschiedenen Größen erhältlich, um eine bequeme und präzise Passform zu gewährleisten. Ob Sie die zusätzliche Stabilität eines Querriemens bevorzugen oder das einfache Design eines traditionellen Riemens, unsere Riemengewährleisten die notwendige Unterstützung, um Ihr Instrument mühelos und stilvoll zu spielen.',
            tableData: {
                columnKeyDef: ['text', 'paddingWidth', 'currency', 'price'],
                columnNameDef: ['', '', '', 'Preis'],
                rows: [
                    { text: 'Akkordeon-Schulterriemen ohne Querriemen'  , price: 'Ab  50', currency: 'CHF / Euro'  , paddingWidth: '45 mm' },
                    { text: 'Akkordeon-Schulterriemen mit Querriemen'   , price: 'Ab  79', currency: 'CHF / Euro'  , paddingWidth: '50 mm' },
                    { text: 'Akkordeon-Schulterriemen mit Querriemen'   , price: 'Ab 100', currency: 'CHF / Euro'  , paddingWidth: '70 mm' },
                    { text: 'Akkordeon-Schulterriemen mit Querriemen'   , price: 'Ab 100', currency: 'CHF / Euro'  , paddingWidth: '80 mm' },
                ]
            }
        },
        AccordionDustCovers: {
            title: 'Staubschutzhüllen',
            text: 'Mit unseren Staubschutzhüllen schützen Sie Ihr Akkordeon vor Verstaubung bei Nichtgebrauch oder vor Kratzern im Rucksack/Koffer durch Schulterriemen. Erhältlich sind die Schutzhüllen in 3 Grössen,  für kleine bis grosse Standardbass- oder Convertor-Akkordeons.',
            tableData: {
                columnKeyDef: ['text', 'currency', 'price'],
                columnNameDef: ['', '', 'Preis'],
                rows: [
                    { text: 'Akkordeon Schutzhülle klein'    , price: '20', currency: 'CHF / Euro' },
                    { text: 'Akkordeon Schutzhülle mittel'   , price: '20', currency: 'CHF / Euro' },
                    { text: 'Akkordeon Schutzhülle gross'    , price: '20', currency: 'CHF / Euro' },
                ],
            }
        },
        AccordionGloveLeftHand: {
            title: 'Akkordeon-Handschuh für die linke Hand',
            text: 'Erleben Sie verbesserten Komfort und Kontrolle mit unserem speziell entwickelten Handschuh für die linke Hand für Akkordeonspieler. Ursprünglich erfunden, um die Hand des Musikers vor der ständigen Reibung und dem Druck beim Bedienen der Bassknöpfe zu schützen, helfen diese Handschuhe auch, eine konstante Temperatur aufrechtzuerhalten und verhindern, dass Schweiß die Leistung beeinträchtigt. Unser Handschuh für die linke Hand ist aus hochwertigen Materialien gefertigt, die sowohl Haltbarkeit als auch Flexibilität gewährleisten und es Ihnen ermöglichen, über längere Zeiträume ohne Unbehagen zu spielen.',
            tableData: {
                columnKeyDef: ['text', 'currency', 'price'],
                columnNameDef: ['', '', 'Preis'],
                rows: [
                    { text: 'Akkordeon Schutz-Handschuh linke Hand', price: '35', currency: 'CHF / Euro' }
                ]
            }
        }
    },
    ConfirmationDialog: {
        DefaultDialogContent: 'Bitte bestätigen Sie Ihre vorgeschlagene Aktion',
        DefaultDialogTitle: 'Bitte bestätigen',
    },
    GeneralComponentLabels: {
        notes: 'Noten',
        range: 'Bereich',
        from: 'Von',
        to: 'Bis',
        cancelButtonLabel: 'Abbrechen',
        deleteButtonLabel: 'Löschen',
        createButtonLabel: 'Erstellen',
        publishButtonLabel: 'Veröffentlichen',
        unpublishButtonLabel: 'Unveröffentlichen',
        manageImagesButtonLabel: 'Bilder verwalten',
        closeButtonLabel: 'Schliessen',
        backButtonLabel: 'Zurück',
        speed: 'Geschwindigkeit',
        paddingWidth: 'Polsterbreite',
        price: 'Preis',
        product: 'Produkt',
        currency: 'Währung',
    },
    ShopShortcut: {
        buy: 'Kaufen',
        rent: 'Mieten',
    }

}

export default germanMessages;
